import {Api, HttpHandler} from 'ag-common'
import {getAccessToken} from './storage'

export default new Api(new HttpHandler('/api/', () => Promise.resolve(getAccessToken()), () => {}))


